import React, { useState } from 'react';
import { Form, Col, Row, Tabs } from 'antd';
import { FormInstance } from 'antd/lib/form';
import HeroTitle from 'components/theme_components/HeroTitle';
import TabPane from 'antd/es/tabs/TabPane';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ConcessionCreation from 'pages/ThirdParty/ThirdPartySFS/ThirdPartyCreation/TabConcession';
import IntramarqueList from './Intra/Intramarque';
import IntermarqueList from './Inter/Intermarque';

export type SiloListProps = {
  tpid: number;
  form: FormInstance;
  color: string;
  itemsCompanyHierarchyTree: any[];
  tptype?: string;
};

const SiloList = ({
  form,
  color,
  tpid,
  itemsCompanyHierarchyTree,
  tptype
}: SiloListProps) => {
  const [tabKey, setTabKey] = useState('1');
  return (
    <Form form={form} className="">
      <HeroTitle
        form={form}
        display
        color={color}
        title="Silo"
        itemsCompanyHierarchyTree={itemsCompanyHierarchyTree}
        className='silo'
      />

      <Tabs className="silos" onChange={(e) => { setTabKey(e) }} >
        <TabPane className={"pt-1 mt-8"} tab={<GetLabel label="intramarque" />} key="1"><IntramarqueList keyProps={tabKey} form={form} tpid={tpid} color={color} itemsCompanyHierarchyTree={[]} tptype={tptype} /></TabPane>
        <TabPane className={"pt-1 mt-8"} tab={<GetLabel label="intermarque" />} key="2"><IntermarqueList keyProps={tabKey} form={form} tpid={tpid} color={color} itemsCompanyHierarchyTree={[]} tptype={tptype} /></TabPane>
      </Tabs>
    </Form>
  );
};

export default SiloList;
